import React from 'react';
import { websiteFeatures } from '../../data/websites';
export function WebsiteFeatures() {
  return <section aria-labelledby="website-features" className="bg-gray-50 px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-1092" data-mp="2ae9bx2erkpgg">
      <h2 id="website-features" className="max-w-[22ch] text-[clamp(2rem,3vw,3.5rem)] font-extrabold leading-tight tracking-tight text-brand-black" data-id="element-1093" data-mp="1vo26podrp2xp">
        Everything a website should have been all along.
      </h2>

      <ul className="mt-12 grid gap-px overflow-hidden rounded-xl border border-gray-200 bg-gray-200 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 min-[2400px]:grid-cols-6" data-id="element-1094" data-mp="1mqhyfvhhm6dl">
        {websiteFeatures.map(feature => <li key={feature.title} className="bg-white p-7 lg:p-8" data-id="element-1095" data-mp="1hp2fqa2s8byd">
            <feature.icon className="h-6 w-6 text-brand-red" aria-hidden="true" data-id="element-1096" data-mp="1hreuked8u677" />
            <h3 className="mt-4 text-lg font-bold leading-snug text-brand-black" data-id="element-1097" data-mp="374s4cj44kmfp">{feature.title}</h3>
            <p className="mt-2 leading-relaxed text-gray-600" data-id="element-1098" data-mp="3c2tmn1tq8hq4">{feature.body}</p>
          </li>)}
      </ul>
    </section>;
}